import { isBlocksPath, isClausesPath, isEndorsementPath, isTemplatePath } from '@utils/app-paths';

export interface PanelMode {
  isTemplate: boolean;
  isBlock: boolean;
  isClause: boolean;
  isEndorsement: boolean;
  isAdminView: boolean;
  isLibraryBlockEdit: boolean;
}

export const getPanelMode = (): PanelMode => {
  const isTemplate = isTemplatePath();
  const isBlock = isBlocksPath();
  const isClause = isClausesPath();
  const isEndorsement = isEndorsementPath();

  return {
    isTemplate,
    isBlock,
    isClause,
    isEndorsement,
    isAdminView: isTemplate || isBlock || isClause,
    isLibraryBlockEdit: isBlock || isClause,
  };
};
